$(document).on('click', '.js-quantity', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $target = $($this.attr('href'));
  const minVal = parseInt($target.attr('min'));
  const currentVal = parseInt($target.val());

  if (!$target.length) {
    return;
  }

  if ($this.hasClass('js-quantity-decrease')) {
    currentVal <= minVal ? $target.val(minVal) : $target.val(currentVal - 1).trigger('change');
  }

  if ($this.hasClass('js-quantity-increase')) {
    $target.val(currentVal + 1).trigger('change');
  }
});
